/**
 * @generated SignedSource<<5ac4d6b7a6ac4ca1b7f74a0af1f5a2aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type requestsInlineFragment$data = {
  readonly id: string;
  readonly contact: {
    readonly " $fragmentSpreads": FragmentRefs<"contactInlineFragment">;
  };
  readonly account: {
    readonly " $fragmentSpreads": FragmentRefs<"accountBaseInlineFragment">;
  };
  readonly preferredPractitioner: {
    readonly " $fragmentSpreads": FragmentRefs<"userProfileBaseInlineFragment" | "userProfileNameInlineFragment">;
  } | null;
  readonly event: {
    readonly " $fragmentSpreads": FragmentRefs<"eventInlineFragment">;
  } | null;
  readonly comment: string | null;
  readonly createdAt: any | null;
  readonly " $fragmentType": "requestsInlineFragment";
};
export type requestsInlineFragment$key = {
  readonly " $data"?: requestsInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"requestsInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "requestsInlineFragment"
};

(node as any).hash = "c4232e6d003382a3ae0366620682d3cc";

export default node;
